"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var autosave;
        (function (autosave) {
            let isDirty = false;
            let timerId = null;
            const AUTOSAVE_KEY = 'dashboard_autosave_' + window.location.pathname;
            const AUTOSAVE_INTERVAL_MS = 60 * 1000;
            function init(canSave) {
                if (!canSave)
                    return;
                $(window).on('beforeunload', () => {
                    if (isDirty)
                        saveNow();
                });
                if (timerId)
                    clearInterval(timerId);
                timerId = window.setInterval(run, AUTOSAVE_INTERVAL_MS);
            }
            autosave.init = init;
            function markDirty() {
                isDirty = true;
            }
            autosave.markDirty = markDirty;
            function run() {
                if (!isDirty)
                    return;
                saveNow();
            }
            function saveNow() {
                const design = designerv2.designer.getDesignForSave();
                if (!design)
                    return;
                const storeObj = {
                    design: design,
                    timestamp: new Date().getTime()
                };
                try {
                    appn.localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(storeObj));
                    isDirty = false;
                    console.log("Design autosaved...");
                }
                catch (e) {
                    console.error("Failed to auto-save the design.", e);
                }
            }
            function getSavedDesign() {
                try {
                    const stored = appn.localStorage.getItem(AUTOSAVE_KEY);
                    if (!stored)
                        return null;
                    const storeObj = JSON.parse(stored);
                    const TEN_MINUTES = 10 * 60 * 1000;
                    if (storeObj && storeObj.timestamp && (new Date().getTime() - storeObj.timestamp < TEN_MINUTES))
                        return storeObj.design;
                    else
                        clear();
                }
                catch (e) {
                    console.error("Failed to retrieve auto-saved design.", e);
                    clear();
                }
                return null;
            }
            autosave.getSavedDesign = getSavedDesign;
            function clear() {
                try {
                    appn.localStorage.removeItem(AUTOSAVE_KEY);
                    isDirty = false;
                }
                catch (e) {
                    console.error("Failed to clear auto-saved design.", e);
                }
            }
            autosave.clear = clear;
        })(autosave = designerv2.autosave || (designerv2.autosave = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
